var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.928,
    height: 47.928,
    viewBox: "0 0 47.928 47.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0,22.464A22.464,22.464,0,1,1,22.464,44.928,22.489,22.489,0,0,1,0,22.464Z",
    fill: "none",
    stroke: "#ca902a",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M2.808,0H0V14.621l8.835,8.835,1.985-1.985L2.808,13.459Z",
    transform: "translate(21.06 8.424)",
    fill: "#f5a623"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.87caef56c8fc2c9c22df8ba8da20ca30.svg";
export { ForwardRef as ReactComponent };